"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InfinitePagination = void 0;
var React = _interopRequireWildcard(require("react"));
var _reactWindow = require("react-window");
var _hooks = require("../../hooks");
var _space = require("../../styles/variables/_space");
var _classify = _interopRequireDefault(require("../../utils/classify"));
var _CircularLoader = require("../CircularLoader");
var _InfinitePaginationModule = _interopRequireDefault(require("./InfinitePagination.module.css"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const DEFAULT_THRESHOLD = 200;
const InfinitePagination = exports.InfinitePagination = /*#__PURE__*/React.forwardRef((props, ref) => {
  const {
    items,
    width = _space.spaceFluid,
    itemSize,
    renderItem,
    threshold = DEFAULT_THRESHOLD,
    getItemKey,
    classNames,
    hasNextPage,
    loadMoreItems,
    isVariableSizeList
  } = props;
  const listRef = React.useRef(null);
  const itemsLength = items.length;
  const totalItemsCount = itemsLength + (hasNextPage ? 1 : 0);
  const [containerRef, containerHeight] = (0, _hooks.useResizeObserver)();

  // @ts-ignore - TS2322 - Type 'null' is not assignable to type 'HTMLDivElement'.
  React.useImperativeHandle(ref, () => listRef.current);
  React.useEffect(() => {
    if (listRef.current) {
      // @ts-ignore - TS2339 - Property 'scrollToItem' does not exist on type 'never'.
      listRef.current.scrollToItem(0);
    }
  }, [itemsLength === 0]);
  const handleScroll = (0, _hooks.useInfiniteScroll)({
    itemSize,
    threshold,
    itemsLength,
    hasNextPage,
    loadMoreItems,
    containerHeight,
    isVariableSizeList
  });

  // @ts-ignore - TS7031 - Binding element 'index' implicitly has an 'any' type. | TS7031 - Binding element 'style' implicitly has an 'any' type.
  const Row = _ref => {
    let {
      index,
      style
    } = _ref;
    return index === itemsLength ? /*#__PURE__*/React.createElement("div", {
      style: style,
      className: _InfinitePaginationModule.default.loader
    }, /*#__PURE__*/React.createElement(_CircularLoader.CircularLoader, {
      size: "large"
    })) : /*#__PURE__*/React.createElement("div", {
      style: style,
      className: _InfinitePaginationModule.default.listRow
    }, renderItem(items[index], index));
  };
  const itemKey = React.useCallback(
  // @ts-ignore - TS7006 - Parameter 'index' implicitly has an 'any' type.
  index => index === itemsLength ? 'loading-indicator' : getItemKey ? getItemKey(items[index], index) : index, [items, getItemKey]);
  const ListComponent = isVariableSizeList ? _reactWindow.VariableSizeList : _reactWindow.FixedSizeList;
  return /*#__PURE__*/React.createElement("div", {
    // @ts-ignore - TS2322 - Type 'Ref<"div">' is not assignable to type 'Ref<HTMLDivElement> | undefined'.
    ref: containerRef,
    "data-testid": "InfinitePagination",
    className: (0, _classify.default)(_InfinitePaginationModule.default.wrapper, classNames?.wrapper)
  }, /*#__PURE__*/React.createElement(ListComponent, {
    ref: listRef,
    width: width,
    height: containerHeight,
    itemKey: itemKey,
    itemSize: itemSize,
    onScroll: handleScroll,
    itemCount: totalItemsCount
  }, Row));
});